import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { UrlProviderService, EndPoints } from 'src/app/service/urlprovider.service';

@Injectable({
    providedIn: 'root'
})
export class CourseHistoryService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    getCourseHistory(urlParam: string): Observable<any> {
        return this.get<any>(EndPoints.get_CourseHistory, undefined, urlParam);
    }

    createCourseHistory(requestPayload: any): Observable<any> {
        return this.post<any>(EndPoints.create_CourseHistory, false, '', requestPayload);
    }

    deleteCourseHistory(requestPayload: any): Observable<any> {
        return this.post<any>(EndPoints.delete_CourseHistory, false, '', requestPayload);
    }

    updateCourseHistory(requestPayload: any): Observable<any> {
        return this.post<any>(EndPoints.update_CourseHistory, false, '', requestPayload);
    }
    getCourseHistorySchoolEnrollments(requestPayload: any): Observable<any> {
        return this.post<any>(EndPoints.get_CourseHistory_SchoolEnrollments, undefined, requestPayload);
    }
}
